import { AppRoleEnum } from '@ulysses-inc/harami_api_client'

export const rolesLeaderOrHigher = [
  AppRoleEnum.OWNER,
  AppRoleEnum.EDITOR,
  AppRoleEnum.LEADER,
] as const
